module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_int_04_6DB79_1SB_H2G.0261bea0.jpg";